import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import _ from 'lodash';

import { jsonStringify } from 'utils/json';

import { parseQueryFilters } from './utils';

const useQueryFilters = ({ filterFields }) => {
  const { search } = useLocation();
  const history = useHistory();

  const filters = useMemo(() => parseQueryFilters(search, filterFields), [search, filterFields]);

  const setFilterValue = useCallback(
    (filterId, value) => {
      const params = new URLSearchParams(history.location.search);

      const isEmptyDateRange = _.isPlainObject(value) && _.isNil(value.start) && _.isNil(value.end);

      if (
        _.isNil(value) ||
        value === '' ||
        (_.isArray(value) && !value.length) ||
        isEmptyDateRange
      ) {
        params.delete(filterId);
      }

      if (
        !_.isNil(value) &&
        value !== '' &&
        (!_.isArray(value) || value.length) &&
        !isEmptyDateRange
      ) {
        const serialized = _.isString(value) ? value : jsonStringify(value);

        params.set(filterId, serialized);
      }

      const nextSearch = params.toString();

      history.replace({
        search: nextSearch ? `?${nextSearch}` : '',
        state: history.location.state,
      });
    },
    [history],
  );

  return { filters, setFilterValue };
};

export default useQueryFilters;
